import { ESliceMenu } from '../../store/slices/menuSlice'
import { useAppSelector } from '../../hook/store';

export interface IRqePerPqrops {
    children: React.ReactElement,
    require: 'create' | 'update' | 'delete' | 'approve'
}

export default function ReqPerm({ children, require }: IRqePerPqrops) {
    const storeState = useAppSelector(state => state)
    const menu = storeState[ESliceMenu.menu]

    if (menu[require] === false) return <></>

    return children;
}
